module.exports = __webpack_public_path__ + "img/unified-empty.c57d07d9.svg";